export default {"src":"/_next/static/media/sia_logo_dark.92db63f5.svg","height":40,"width":71,"blurWidth":0,"blurHeight":0};